@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}

<div class="ogp-market-help">
    @if (displayMultiSelectionText) {
        <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="multiSelectionHelpText" />
    }
</div>
@if (optionsLayout) {
    <div class="option-group-container correct-score-container" [ngClass]="scoreOptionsClass">
        <div class="option-group-header">
            @for (name of headerName; track name) {
                <span>{{ name }}</span>
            }
        </div>
        @for (option of optionsLayout.options; track option?.id; let i = $index) {
            <ng-container *ngTemplateOutlet="optionTemplate; context: { option: option, hideOption: !isScoreOptionVisible(i) }" />
            @if (!option) {
                <div
                    class="option option-placeholder"
                    [class.option-hidden]="!isScoreOptionVisible(i)"
                    [class.option-placeholder-shadow]="isPlaceholderShadowVisible(i)"></div>
            }
        }
    </div>

    <div class="option-group-container correct-score-container single">
        @for (option of optionsLayout.rest; track option.id; let i = $index) {
            <ng-container *ngTemplateOutlet="optionTemplate; context: { option: option, hideOption: !isAdditionalOptionVisible(i) }" />
        }
    </div>
}

@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}

<ng-template #optionTemplate let-option="option" let-hideOption="hideOption">
    @if (!!option) {
        <ms-bet-builder-option
            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
            [option]="option"
            [optionGroup]="optionGroup"
            [event]="event"
            [showMarketAttribute]="false"
            [class.option-hidden]="hideOption"
            [showPromoBadge]="!!crmPromotedOptionIdsMap[option.id]"
            [sourceOfPick]="sourceOfPick" />
    }
</ng-template>
